module.exports = __webpack_public_path__ + "img/sign-71.67ea1017.jpg";